import { ProfileResponse } from 'models/profile';
import client from './client';

export const getProfile = (idAccount: string) =>
  client.get<ProfileResponse>(`ag/profile/ms/v1/profiles/${idAccount}`);
